export default class Api {

    static paramsString = (params: Object) => {
        const result = '?' + Object.entries(params).map((e) => `${e[0]}=${e[1]}`).join('&');
        return result;
    }

    static paramsNullDelete = (params: any) => {
        for (let k in params) {
            if (params[k] === "") {
                delete params[k];
            }
        }
    }

}